var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pan-simple-header'),_c('div',{staticClass:"office-iframe-content"},[_c('iframe',{staticClass:"office-iframe",attrs:{"src":_vm.showPath,"frameborder":"0"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }